import React, { useState } from "react";
import "./Subscription.css";
import { GoArrowRight } from "react-icons/go";

import MultiStepForm from "../global/MultiStepForm";
import hilights from "../../src/assets/insta/hilights.png";

const Subscription = () => {
  const [showModal, setShowModal] = useState(false);

  const handlePremiumClick = async () => {
    setShowModal(true);
  };

  return (
    <div className="main global subscription">
      <h2>Subscription Plans</h2>
      <h4>Eating Healthy, Made Simple & Affordable!</h4>

      <div className="subsectionplans">
        <div className="plan">
          <h3>Weekly Subscription Plan</h3>
          <p>
            Perfect for newcomers or those wanting to try a short-term
            commitment to see the benefits of fresh, hot meals delivered
            regularly.
          </p>
          <ul>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>Flexible meal options</span>
            </li>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>Weekly menu variety to prevent monotony</span>
            </li>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>Skip or change meals easily within the week</span>
            </li>
          </ul>
          <a href="#formnavhref">
            <button>Subscribe Now</button>
          </a>
        </div>
        <div className="plan">
          <h3>Monthly Subscription Plan</h3>
          <p>
            Ideal for those committed to their health goals, this plan ensures a
            month of balanced, high-quality meals.
          </p>
          <ul>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>Priority meal customization</span>
            </li>
            <li>
              {" "}
              <GoArrowRight className="text-[20px]" />
              <span>Complimentary nutrition consultation</span>
            </li>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>10% off on premium add-ons</span>
            </li>
            {/* <li>
              <GoArrowRight className="text-[20px]" />
              <span>Starting at ₹X,XXX/month</span>
            </li> */}
          </ul>
          <a href="#formnavhref">
            <button>Subscribe Now</button>
          </a>
        </div>

        <div className="plan" id="premium">
          <h3>Bhookr Premium</h3>
          <p>
            Designed for intense fitness and health goals, this premium plan
            offers high-protein, calorie-counted meals tailored to your diet.
          </p>
          <ul>
            <li>
              {" "}
              <GoArrowRight className="text-[20px]" />
              <span>
                Direct consultations with nutritionists to set exact macros
              </span>
            </li>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>
                Exclusive high-protein meal options and performance add-ons
              </span>
            </li>
            <li>
              <GoArrowRight className="text-[20px]" />
              <span>
                Premium priority in delivery timing and dietary adjustments
              </span>
            </li>
          </ul>

          <button onClick={handlePremiumClick}>Coming Soon</button>
        </div>
      </div>
      <div className="hilightplans" id="formnavhref">
        <div>
          <h3>
            Your <br />
            <span className="text-[#fff]">Journey</span> Starts Here..
          </h3>
          <p>Delight & Joys</p>
        </div>
        <img src={hilights} alt="hilights-bhhokr" loading="lazy" />
      </div>
      <MultiStepForm />

      {showModal && (
        <div className="modal-overlay">
          <div className="modalData" id="modalDataoverallclosures">
            <p className="closemodal" onClick={() => setShowModal(false)}>
              ✖
            </p>
            <h3 className="mt-7 font-semibold">
              Bhookr Premium is temporarily locked by the admin.
            </h3>
            <p className="text-m mt-1">
              This means the premium features are currently unavailable.
            </p>
            <p className="text-m mt-1">
              We are working on making Bhookr Premium available soon. Please
              check back later or contact support for more details.
            </p>
            <p className="text-m mt-1">Thank you for your understanding.</p>
            <div className="modal-buttons ">
              <button type="button" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscription;
